const config = state => state.app.config
const palette = state => state.app.config.palette
const isLoading = state => state.app.isLoading
const loggedIn = state => !!state.app.user
const UserName = state => state.app.user.username
const SourcesSites = state => state.app.SourcesSites
const allowedSourceSitesList = state =>
  state.app.SourcesSites.map(item => item.domain_name)
const PaymentsMethods = state => state.app.PaymentsMethods
const PaymentsMethodsDomainNames = state =>
  state.app.PaymentsMethods.map(item => item.domain_name)
const OrderStatuses = state => state.app.OrderStatuses
const Orders = state => state.orders.orders
const FreeOrders = state => state.orders.freeOrders
const Ipns = state => state.orders.ipns
const dataTiktok = state => state.tiktok.dataTiktok
const dataTiktokMore = state => state.tiktok.dataTiktokMore
const dataSuppliers = state => state.suppliers.suppliers
const supplierProducts = state => state.supplierProduct.supplierProducts

export {
  config,
  palette,
  isLoading,
  loggedIn,
  SourcesSites,
  UserName,
  allowedSourceSitesList,
  PaymentsMethods,
  Orders,
  FreeOrders,
  OrderStatuses,
  PaymentsMethodsDomainNames,
  dataTiktok,
  dataTiktokMore,
  Ipns,
  dataSuppliers,
  supplierProducts,
}
